import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import { Button } from '../../ui/button';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { Pencil, Copy, Trash2 } from 'lucide-react';
import PricingBandModal from './PricingBandModal';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';
import { Spinner } from '../../ui/spinner';

const PriceBands = ({ branding, getAllItemsFromDB, priceBands, tableName, toggleModal, showLoader, contractApprover }) => {
  const { headers } = branding?.fonts[0]?.font;

  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newPricingBand, setNewPricingBand] = useState(false);

  useEffect(() => {
    getAllItemsFromDB(tableName);
  }, [getAllItemsFromDB, tableName]);

  useEffect(() => {
    setData(priceBands);
  }, [priceBands]);

  const userActions = ({ rowData }) => {
    return (
      <div className='flex items-center justify-center'>
        <div className='flex items-center gap-2'>
          {!rowData.inUse && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Pencil size={16} strokeWidth={1.5} className='cursor-pointer' onClick={() => setShowModal(rowData)} />
              </TooltipTrigger>
              <TooltipContent>Edit Pricing Band</TooltipContent>
            </Tooltip>
          )}
          <Tooltip>
            <TooltipTrigger asChild>
              <Copy
                size={16}
                strokeWidth={1.5}
                className='cursor-pointer'
                onClick={() => {
                  const newData = { ...rowData };
                  const keysToDelete = ['created', 'modified', 'id', 'modifiedBy'];
                  Object.keys(newData).forEach((key) => {
                    if (keysToDelete.includes(key)) {
                      delete newData[key];
                    } else if (['name'].includes(key)) newData[key] = '';
                  });
                  setShowModal(newData);
                }}
              />
            </TooltipTrigger>
            <TooltipContent>Copy Pricing Band</TooltipContent>
          </Tooltip>
          {contractApprover && !rowData.inUse && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Trash2
                  size={16}
                  strokeWidth={1.5}
                  className='cursor-pointer'
                  onClick={() => toggleModal(true, 'pricingBand-table-delete', rowData)}
                />
              </TooltipTrigger>
              <TooltipContent>Delete Pricing Band</TooltipContent>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  /* if (showLoader) {
    return <LinearProgress color='inherit' />;
  } */

  return (
    <TooltipProvider>
    <section className='panel' style={{ fontFamily: headers }}>
      <header
        className='panel-heading'
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        Price Bands
        <div style={{ display: 'flex' }}>
          <Button onClick={() => setNewPricingBand(true)}>
            Add New Pricing Band
          </Button>
        </div>
      </header>
      <div id='contract-not-found' className='panel-body' style={{ height: '100vh' }}>
        {showLoader && (
          <div>
            <Spinner />
          </div>
        )}

        <div style={{ minWidth: '100%', height: '100%', display: data?.length ? 'block' : 'none' }}>
          {data?.length && (
            <AutoSizer>
              {({ width, height }) => (
                <Table
                  width={width}
                  height={height}
                  rowHeight={50}
                  headerHeight={60}
                  headerStyle={{ verticalAlign: 'bottom', width: '100%', display: 'flex', justifyContent: 'center' }}
                  rowStyle={{ textAlign: 'center' }}
                  headerClassName='admin_portal_column_headers'
                  rowCount={data && data.length}
                  rowGetter={({ index }) => data[index]}>
                  <Column label='Document Id' dataKey='id' width={450} />
                  <Column label='Name' dataKey='name' width={400} />
                  <Column label='Created' dataKey='created' width={400} />
                  <Column label='Modified' dataKey='modified' width={400} />
                  <Column label='Modified By' dataKey='modifiedBy' width={400} />
                  <Column label='Actions' dataKey='actions' width={400} cellRenderer={userActions} />
                </Table>
              )}
            </AutoSizer>
          )}
        </div>
      </div>
      {(showModal || newPricingBand) && (
        <PricingBandModal
          rowData={showModal}
          setShowModal={setShowModal}
          isNew={newPricingBand}
          setIsNew={setNewPricingBand}
        />
      )}
    </section>
    </TooltipProvider>
  );
};

const mapStateToProps = (state) => {
  const { contractApprover } = state?.profile?.details || {};
  const tableName = 'pricingBands';

  return {
    priceBands: state?.admin?.adminPortal?.[tableName],
    branding: state.branding,
    tableName,
    showLoader: state.showLoader,
    contractApprover,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllItemsFromDB: (table) => dispatch(ADMINACTIONS.getAllItemsFromDB(table)),
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PriceBands);
